<template>
  <v-app>
    <v-card row align-center style="max-width: 400px;  width:100%;" class="mx-auto mt-5">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form @keyup.enter.native="signin()">
          <v-text-field
            color="primary"
            v-model="form.username"
            :error-messages="emailErrors"
            label="E-mail"
            required
            @input="$v.form.username.$touch()"
            @blur="$v.form.username.$touch()"
          ></v-text-field>

          <v-text-field
            color="primary"
            :append-icon="!show ? 'mdi-eye' : 'mdi-eye-off'"
            @input="$v.form.password.$touch()"
            @blur="$v.form.password.$touch()"
            :error-messages="passwordErrors"
            :type="show ? 'text' : 'password'"
            label="Password"
            hint="Also use uppercase characters and numbers"
            v-model="form.password"
            class="input-group--focused"
            @click:append="show = !show"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row justify="space-around">
          <v-btn color="primary" large dark @click="signin()">Sign in</v-btn>

          <!-- <v-btn class="right" @click="clear()">clear</v-btn> -->
        </v-row>
      </v-card-actions>
      <v-card-text>
        <p>
          This page is protected by reCAPTCHA, and subject to
          <a href="https://policies.google.com/privacy">Google’s Privacy Policy</a>
          &
          <a href="https://policies.google.com/terms">Terms of Service</a>.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-row justify="space-around">
          <v-btn to="/forgotPassword" dark color="primary" class="lighten-2"
            >Forgot password?</v-btn
          >
          <v-btn to="/register" dark color="primary" class="lighten-2">Register</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-app>
</template>
<script>
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
  created() {},
  mounted() {
    // this.$recaptchaLoaded();
  },
  data: () => ({
    form: {
      username: '',
      password: '',
    },
    show: false,
  }),
  validations: {
    form: {
      username: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
      },
    },
  },

  computed: {
    color() {
      return localStorage.getItem('appbasecolor')
        ? localStorage.getItem('appbasecolor')
        : this.$store.getters.appBaseColor;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.form.username.$dirty) return errors;
      !this.$v.form.username.email && errors.push('Must be valid e-mail');
      !this.$v.form.username.required && errors.push('E-mail is required');
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;
      !this.$v.form.password.minLength && errors.push('Min 8 characters');
      !this.$v.form.password.required && errors.push('Password is required');
      return errors;
    },
  },

  methods: {
    signin() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      // this.$store.dispatch('verifyRecapthca', 'login').then((result) => {
      //   if (result.data.errorMessage) {
      //     this._vm.showError(result.data.errorMessage);
      //   } else if (result.data.success) {
      this.$store.dispatch('login', {
        email: this.form.username.toLowerCase(),
        password: this.form.password,
      });
      //   }
      // });
    },
    // clear() {
    //   this.$v.$reset();
    //   (this.form.username = ''), (this.form.password = '');
    // },
  },
  watch: {},
};
</script>

<style></style>
